module.exports = __webpack_public_path__ + "yz/img/百世.e057c973.jpg";